import { Injectable } from '@angular/core';
import { Rotas } from '@core/enums/routes';
import { HttpClientProtectedService } from '@core/services/auth/http-client-protected.service';
import {
	OpcoesAgrupamentosFiltradas,
	FiltroAgrupamentoDTO,
} from '@modulos/home/submodulos/dados-meteorologicos/interfaces/filtro-agrupamento';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class OpcoesAgrupamentosFiltradosService {
	constructor(private http: HttpClientProtectedService) {}

	getOpcoes(
		dto: FiltroAgrupamentoDTO[]
	): Observable<OpcoesAgrupamentosFiltradas> {
		return this.http.post(`${Rotas.AGRUPAMENTO}/opcoes-filtradas`, dto);
	}
}
